import { jsx as e, jsxs as p } from "react/jsx-runtime";
import { forwardRef as c, useContext as f } from "react";
import { Context as h } from "./context.js";
import { Label as x, Input as C } from "./styles.js";
const l = c(
  ({ value: o, children: r, disabled: t, className: s, ...a }, i) => {
    const { name: n, value: d, onChange: m } = f(h);
    return /* @__PURE__ */ e("div", { className: s, children: /* @__PURE__ */ p(x, { children: [
      /* @__PURE__ */ e(
        C,
        {
          ...a,
          ref: i,
          type: "radio",
          disabled: t,
          name: n,
          value: o,
          checked: d === o,
          onChange: m
        }
      ),
      r && /* @__PURE__ */ e("span", { children: r })
    ] }) });
  }
);
l.displayName = "Radio";
export {
  l as Radio
};
//# sourceMappingURL=Radio.js.map
